// extracted by css-extract-rspack-plugin
export default {"list":"jzLWq","closeButton":"Y92af","tab":"V3QbA"};